export const msToSec = (ms: number, decimals = 0): number => {
  return +(ms / 1000).toFixed(decimals);
};
